/*global $, document, window, setTimeout, alert, FG, confirm, location, FGT_CONFIG, console, navigator*/
(function () {
    'use strict';
    FG.Modals = {
        init: function () {},

        initCarousel: function (column) {
            var itemQuantity = $('.item').length,
                multipleScroll = null;

            //if on screen smaller than 622px, only scroll one item at a time
            if (typeof window.matchMedia != 'undefined') {
                multipleScroll = window.matchMedia(
                    'all and (min-width: 622px)'
                ).matches;
            } else {
                multipleScroll = false;
            }

            //if # of upsell items is larger than carousel column #, show carousel navigation
            if (
                itemQuantity > column ||
                (!multipleScroll && itemQuantity > 1)
            ) {
                $('.carousel-control').removeClass('hide');
            }

            $('.upsell').find('.item :first').addClass('active');
            $('#upsellCarousel').carousel({ interval: false, wrap: false });

            $('#upsellCarousel').on('slid.bs.carousel', '', function () {
                var $this = $(this);

                $this.children('.carousel-control').show();

                if ($('.carousel-inner .item:first').hasClass('active')) {
                    $this.children('.left.carousel-control').hide();
                } else if ($('.carousel-inner .item:last').hasClass('active')) {
                    $this.children('.right.carousel-control').hide();
                }
            });

            if (multipleScroll) {
                $('#upsellCarousel').addClass('multiscroll');
                $('.carousel .item').each(function (index) {
                    var current = $(this);
                    var next = current.next();

                    for (var i = 1; i < column; i++) {
                        if (next.length) {
                            next.children(':first-child')
                                .clone()
                                .appendTo(current);
                            next = next.next();
                        } else if (index > 0) {
                            current.remove();
                        }
                    }
                });
            }
        },

        resetErrors: function (form) {
            form.find('.error').removeClass('error');
            form.find('.controls-row.errors span').addClass('hidden');
            form.find('.invalid').removeClass('invalid');
            form.find('.controls-row.invalid span').addClass('hidden');
            form.find('.error-msg').addClass('hide');
        },

        initValidateForm: function (id) {
            var self = this;
            var Form = $('#' + id);
            self.resetErrors(Form);
            Form.find('.required').each(function () {
                var id = $(this).attr('id');
                var $this = $(this);
                $(this).blur(function () {
                    if (!$this.val()) {
                        $this.addClass('invalid');
                        Form.find('label[for="' + id + '"]').addClass(
                            'invalid'
                        );
                        $this.parent().addClass('invalid');

                        $this.attr('aria-describedby', id + '-error-msg');
                        // Hide all error messages for the input to only show the required message
                        $('[id^=' + id + '-error-msg]').addClass('hide');
                        $('#' + id + '-error-msg').removeClass('hide');
                    } else {
                        $this.removeClass('invalid');
                        Form.find('label[for="' + id + '"]').removeClass(
                            'invalid'
                        );
                        $this.parent().removeClass('invalid');
                        $('#' + id + '-error-msg').addClass('hide');
                        $this.attr('aria-describedby', '');
                    }
                });
            });
        },

        passwordCheck: function (str) {
            var lower = new RegExp('[a-z]'),
                upper = new RegExp('[A-Z]'),
                numb = new RegExp('[0-9]');
            if (
                str.length > 7 &&
                lower.test(str) &&
                upper.test(str) &&
                numb.test(str)
            ) {
                return true;
            }
            return false;
        },

        initPasswordCheck: function (form_id) {
            var self = this,
                lower = new RegExp('[a-z]'),
                upper = new RegExp('[A-Z]'),
                numb = new RegExp('[0-9]'),
                new_pass = $('#' + form_id + ' input[name="new_password"]'),
                submit_button = $('#' + form_id + ' input[type="submit"]'),
                bar = new_pass.parents().find('div.progress-bar'),
                confirm_pass = $(
                    '#' + form_id + ' input[name="confirm_password"]'
                ),
                matchmsg = confirm_pass.parents().find('div.match-msg');

            new_pass.keyup(function () {
                self.resetErrors($('#' + form_id));

                var val = $(this).val(),
                    confirm_val = confirm_pass.val(),
                    new_width = val.length * 18;

                if (confirm_val && confirm_val !== val) {
                    confirm_pass.val('');
                    matchmsg.hide();
                    submit_button.removeClass('btn-primary');
                }

                bar.css('width', new_width + 'px');
                bar.addClass('progress-bar-warning');

                if (lower.test(val)) {
                    $('.map-one-lower').addClass('highlight');
                    $('.map-one-lower .sr-only').text('(completed)');
                } else {
                    $('.map-one-lower').removeClass('highlight');
                    $('.map-one-lower .sr-only').text('');
                }
                if (upper.test(val)) {
                    $('.map-one-upper').addClass('highlight');
                    $('.map-one-upper .sr-only').text('(completed)');
                } else {
                    $('.map-one-upper').removeClass('highlight');
                    $('.map-one-uppper .sr-only').text('');
                }
                if (numb.test(val)) {
                    $('.map-one-number').addClass('highlight');
                    $('.map-one-number .sr-only').text('(completed)');
                } else {
                    $('.map-one-number').removeClass('highlight');
                    $('.map-one-number .sr-only').text('');
                }
                if (val.length > 7) {
                    $('.map-len-eight').addClass('highlight');
                    $('.map-len-eight .sr-only').text('(completed)');
                } else {
                    $('.map-len-eight').removeClass('highlight');
                    $('.map-len-eight .sr-only').text('');
                }

                if (
                    val.length > 7 &&
                    lower.test(val) &&
                    upper.test(val) &&
                    numb.test(val)
                ) {
                    bar.removeClass('progress-bar-warning');
                    bar.addClass('progress-bar-success');
                }
            });

            //also confirmation
            confirm_pass.keyup(function () {
                self.resetErrors($('#' + form_id));

                var newpass_val = new_pass.val(),
                    confirm_val = $(this).val();

                if (
                    confirm_val.length > 7 &&
                    confirm_val == newpass_val &&
                    bar.hasClass('progress-bar-success')
                ) {
                    matchmsg.show();
                    $(this).removeClass('invalid error');
                    $(this).parent().removeClass('invalid error');
                    $(this).parent().find('label').removeClass('invalid error');
                    if ($('#' + $(this).attr('id') + '_error').length > 0) {
                        $('#' + $(this).attr('id') + '_error').remove();
                        $(this).attr('aria-describedby', '');
                    }

                    submit_button.addClass('btn-primary');
                } else {
                    matchmsg.hide();
                    if ($('#' + $(this).attr('id') + '_error').length == 0) {
                        var $errMsg = $('<div/>', {
                            id: $(this).attr('id') + '_error',
                        }).html(
                            window.FGTLibs.i18n.t(
                                'Password values do not match'
                            )
                        );
                        $(this).addClass('invalid error');
                        $(this).parent().addClass('invalid error');
                        $(this)
                            .parent()
                            .find('label')
                            .addClass('invalid error');
                        $(this).parent('div').append($errMsg);
                        $(this).attr(
                            'aria-describedby',
                            $(this).attr('id') + '_error'
                        );
                    }
                    submit_button.removeClass('btn-primary');
                }
            });
        },

        initMyAccount: function () {
            var state_select = $('#my_select_state'),
                user_state = $('#my_state_other').val();

            if (user_state) {
                //set select menu to reflect user current state
                state_select
                    .find('option[value="' + user_state + '"]')
                    .prop('selected', true);
            }
        },
    };
})();
